/** Hand-written guide copy. There is no generation pipeline for these texts. */
export enum GuideLocaleStatusEnum {
    EMPTY = 'empty',
    READY = 'ready',
}
